export enum UserRole {
  admin = 'admin',
  traveler = 'traveler',
  shopper = 'shopper',
  sender = 'sender',
  logisticsPartner = 'logistics_partner'
}
